const translations = {
  "en": {
    "Cash Optimization": "Cash Optimization",
    "Financial Security": "Financial Security",
    "Life Decisions": "Life Decisions",
    "Wealth Building": "Wealth Building"
  },
  "zh-tw": {
    "Cash Optimization": "現金優化",
    "Financial Security": "財務安全",
    "Life Decisions": "人生抉擇",
    "Wealth Building": "財富建立"
  }
};

export default translations;
